import React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { compose } from 'ramda';

import { validateAsyncComponent } from '../../HoC';
import actions from '../../../store/actions';
import SearchOptionFilterGroup from './SearchOptionFilterGroup.jsx';
import styleFile from './SearchOptionFilter.js';
import { RichText, Button } from '@synergycms_core/components/generic';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from 'synergycms_core/src/components/providers/themeProvider';

const { filters: filtersActions } = actions.customer;

/**
 * TODO
 * Component price pels rangs
 * Al clicar fora, tancar
 */

// FIXME: Que passa quan es plega sense botó?
// FIXME: Translations
class SearchOptionFilter extends React.Component {
  static displayName = 'SearchOptionFilter';
  constructor(props) {
    super(props);

    const { config } = this.props;
    this.options = config.options;

    this.clearSelected = this.clearSelected.bind(this);
    this.doApplyFilters = this.doApplyFilters.bind(this);
    this.setFilter = config.setFilter.bind(this);
    this.clearFilters = config.clearFilters.bind(this);
    this.applyFilters = config.applyFilters.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.element = ReactDOM.findDOMNode(this);
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(e) {
    if (!e || (this.element.contains && document.contains && !this.element.contains(e.target) && document.contains(e.target))) {
      e && e.preventDefault();
      this.props.config.toggleSelected('filters')(e);
    }
  }

  doApplyFilters = e => {
    this.applyFilters();
    this.props.config.toggleSelected('filters')();
  };

  clearSelected(e) {
    e.preventDefault();
    this.clearFilters();
    this.props.config.toggleSelected('filters')(e);
  }

  render() {
    const { theme } = this.props;
    const { classes } = theme.styles;

    return (
      <div className={theme.computedInnerStyle}>
        <div className={classes.filterContainer}>
          {this.props.theme.width < 1001 && (
            <RichText translate={true} ucFirst={true} text={'filtros'} innerStyle={classes.filterHeaderTitle} />
          )}
          {this.props.theme.width < 1001 && (
            <Button
              onClick={this.props.config.toggleSelected()}
              innerStyle={['closeButton']}
              icon={{ unicodeContent: 'e001' }}
              defaultStyle={false}
              ariaLabel={'_%filtros%_'}
              translate={true}
            />
          )}
          {this.props.config.options.valueSeq()
            .map(type => {
              const key = type.get('key');
              return (
                <SearchOptionFilterGroup
                  onChange={this.setFilter(key)}
                  options={type.get('options')}
                  title={type.get('title')}
                  type={key}
                  key={key}
                  innerStyle={'filterContainer'}
                />
              );
            })}
        </div>
        <div className={classes.controls}>
          <Button
            onClick={this.clearSelected}
            innerStyle={['toggleMainButtonReverse', 'searchOptionsFilterButtonReverse']}
            richText={{
              text: '_%borrar todo%_',
              translate: true,
              ucFirst: true,
              innerStyle: ['fontSize13', 'block', 'toggleMainLinkReverse']
            }}
          />
          <Button
            onClick={this.doApplyFilters}
            innerStyle={['toggleMainButton', 'searchOptionsFilterButton']}
            richText={{
              text: '_%aplicar filtros%_',
              translate: true,
              ucFirst: true,
              innerStyle: ['toggleMainButton']
            }}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clearFilters: () => {
      dispatch(filtersActions.clear());
    },
    setFilter: type => code => e => {
      /**
       * TODO: https://stackoverflow.com/questions/30426523/why-does-preventdefault-on-checkbox-click-event-returns-true-for-the-checked-att
       * In chrome works fine but with some other browsers may not work
       *
       * If preventDefault a checkbox event rollback value
       *
       * Check Internet Explorer for add e.preventDefault();
       */

      let eventName;
      if (type === 'stars') {
        eventName = e.target.checked ? 'add_filter_stars' : 'del_filter_stars';
      }

      if (type === 'prices') {
        eventName = e.target.checked ? 'add_filter_prices' : 'del_filter_prices';
      }

      if (eventName) {
        dispatch(actions.events.trigger(eventName, { code }));
      }

      dispatch(filtersActions.set(type, code, e.target.checked));
    },
    applyFilters: () => {
      dispatch(filtersActions.apply());
    }
  };
};

const mapStateToProps = store => {
  const filters = store.getIn(['customer', 'filters']);
  return {
    options: filters.get('options') || undefined,
    hotels: filters.get('hotels') || undefined
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'theme',
    'avail',
    'descriptive',
    'options',
    'hotels',
    'clearFilters',
    'setFilter',
    'applyFilters',
    'toggleSelected'
  ]),
  withThemeJSS({ styleFile })
)(SearchOptionFilter);
